import Vue from 'vue'
import Vuex from 'vuex'

// 1.安装插件
Vue.use(Vuex)
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import login from './modules/login'
import setting from './modules/setting'
// 2.创建对象
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: { // 子vuex状态模块注册
    namespaced: true, // 为了解决不同模块命名冲突的问题
    login,
    setting
  }
})

// 3.导出store对象
export default store



// WEBPACK FOOTER //
// ./src/store/index.js